import { updateUserDetailsType } from './UserDetailsConstants';

// eslint-disable-next-line import/prefer-default-export
export function updateUserDetails(details) {
  return {
    type: updateUserDetailsType,
    payload: {
      details,
    },
  };
}
